import {View} from "react-native";
import AvatarM from "@common/components/avatar/AvatarM";
import FontAwesome5 from "react-native-vector-icons/FontAwesome5";
import {theme} from "@common/theme/theme";
import {Badge} from "react-native-paper";
import React from "react";
import {apiIdle, apiRequest} from "@data/redux/actions/api";
import {connect} from "react-redux";
import forbidden from "@assets/icons/generic/forbidden.png"
import photo from "@assets/icons/activity-steps/photo.png"
import { IconImageM } from "@common/components/icons/IconsM"
import TouchableRippleM from "@common/components/button/TouchableRippleM"
import { DialogM } from "@common/components/alert/dialog/Dialog"
import { hasRole } from "@data/utility/ability"

const LiveAvatarM = props => {

    const {user, size = 50, style, noOutOfApp = false} = props
    const isOnline = !!props.participants?.find(x => x === user?.id)
    const isOutOfApp = hasRole(props.currentUser, "tutor") && props.outOfAppIds?.find((id) => id === user?.id)
    const isSoundMode = hasRole(user, "tutor") || props.soundModeIds?.find((id) => id === user?.id)
    const isActivityCameraOn = props.activityCameraOnIds?.find((id) => id === user?.id)

    // if (!props.isLive) return null

    const isHandRaised = !!props.raisedHands?.find(x => x?.toString() === user?.id?.toString())
    // console.log(props.inCallUsers)
    // const participants = useParticipants();
    // const participant = participants?.find(x => user?.id === parseInt(x?.identity?.split(".")?.[0]))


    return <View style={{...style}}>
        <AvatarM user={user} style={{marginRight: 2, ...style}} size={size}/>
        {isHandRaised && !noOutOfApp && <FontAwesome5 name="hand-paper"
                                       solid
                                       size={14}
                                       style={{
                                           position: "absolute",
                                           bottom: 14,
                                           right: 0
                                       }}
                                       color={theme.colors.accent}/>}
        {user?.id !== 0 && user?.id !== props.currentUser?.id && <Badge
            style={{
                backgroundColor: (isOnline ? theme.colors.success : theme.colors.light),
                position: "absolute",
                bottom: 0,
                right: 0
            }}
            size={12}
        />}
        {user?.id !== 0 && !noOutOfApp && isOnline && (isActivityCameraOn ? <TouchableRippleM
            style={{
                position: "absolute",
                top: 0,
                right: 0
            }}
            onPress={() => {
                DialogM.show({
                    champion: "abou",
                    text1: `📷 ${user?.display_name} est en train de prendre une photo sur son activité`,
                    text2: ``,
                })
            }}
        >
            <IconImageM source={photo}
                        width={18}
                        style={{
                            tintColor: theme.colors.primary
                        }}
            />
        </TouchableRippleM> : (isOutOfApp) ? <TouchableRippleM
            style={{
                position: "absolute",
                top: 0,
                right: 0
            }}
            onPress={() => {
                DialogM.show({
                    champion: "abou",
                    text1: `👻 ${user?.display_name} est sorti de son écran d'activité`,
                    text2: `Il est sur une autre appli ou a verrouillé son appareil, c'est peut-être le moment de lui tirer les oreilles !`,
                })
            }}
        >
            <IconImageM source={forbidden}
                     width={18}
                     style={{
                     }}
        />
        </TouchableRippleM> : null)}
        {/*{participant && <OutOfAppStateBadge participant={participant}/>}*/}
    </View>
}
const mapStateToProps = state => {
    return {
        currentUser: state.data.currentUser?.object,
        liveSessions: state.data.currentUser?.object?.live_sessions,
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(x => x?.id === state.liveMode?.liveSessionId),
        liveSessionId: state.liveMode?.liveSessionId,
        participants: state.liveMode?.liveParticipants,
        inCallUsers: state.liveMode?.inCallUsers,
        raisedHands: state.liveMode?.raisedHands,
        voiceActivityRecordingIds: state.liveMode?.voiceActivityRecordingIds,
        getSessionsRequest: state.api.getLiveSession?.request,
        isLive: state.liveMode.isLiveModeEnabled,
        outOfAppIds: state.liveMode?.outOfAppIds,
        activityCameraOnIds: state.liveMode?.activityCameraOnIds,
        soundModeIds: state.liveMode?.soundModeIds,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle
};

export default connect(mapStateToProps, mapDispatchToProps)(LiveAvatarM)